import { render, staticRenderFns } from "./vt-top-app-bar-fixed-ajust.vue?vue&type=template&id=1b1ff465&scoped=true&"
import script from "./vt-top-app-bar-fixed-ajust.vue?vue&type=script&lang=ts&"
export * from "./vt-top-app-bar-fixed-ajust.vue?vue&type=script&lang=ts&"
import style0 from "./vt-top-app-bar-fixed-ajust.vue?vue&type=style&index=0&id=1b1ff465&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1ff465",
  null
  
)

export default component.exports